import React, {useEffect} from "react";
import { configuration } from "../../helpers/config";
import BrandPage from '../../components/BrandPageComponent'
import {BrandPageFetcher} from "../../utils/GenUtils";
import {useDispatch} from "react-redux";
import {UPDATE_LOB_VALUE} from "../../redux/ActionTypes";
import { FetchSubMenu } from "../../utils/apiCall";
import { MenuFunction,FooterFunction } from "../../utils/menu";
import axios from "axios";

export async function getServerSideProps(context) {
  const { req } = context;
  const currentUrl = `${req.headers.host}`;
  const apiData = await axios.get(
    `${configuration.APP_URL_CONTENTS}/dealer-code?url=${currentUrl}`,
  );
  const lobData = apiData?.data?.result?.[0] || "" ;
  const Menudata = await MenuFunction(lobData?.dealerCode);
  const Footerdata = await FooterFunction(lobData?.dealerCode);
  const SubMenudata = await FetchSubMenu();
  let props = {
    data: {},
    error: false,
    Menudata:Menudata,
    SubMenudata:SubMenudata,
    Footerdata:Footerdata,
  }
  // let props = {
  //   data: {},
  //   error: false
  // }
  const { brand } = context.params;
  // console.log(brand,"brand")
  let newData= await BrandPageFetcher(brand, props, configuration.COMMON_MASTER_LOB);
  // console.log(newData,"brand 1")
  props.data = newData;
  return {props};
}

export default function CarBrandPage(props) {
  const dispatch = useDispatch()


  useEffect(() => {
    dispatch({type: UPDATE_LOB_VALUE, payload: configuration.COMMON_MASTER_LOB})
  },[])

  return (
      <BrandPage {...props.data.props} submenudata = { props?.SubMenudata}/>
  )

}
